module.exports = __webpack_public_path__ + "img/voucherCenteBanner1.e51cc492.png";